import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const logo = '/images/logos/Hairchitech_Logo1.png';

const PublicFooter = () => {
  const { t } = useTranslation('marketing');

  return (
    <footer className="bg-gray-50 py-16">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-12">
          <div>
            <div className="flex items-center mb-4">
              <Link to="/">
                <img src={logo} alt="Hairchitech" className="h-8 w-8 cursor-pointer" />
              </Link>
              <span className="ml-3 text-lg font-semibold text-gray-900">Hairchitech</span>
            </div>
            <p className="text-gray-600 text-sm">
              {t('marketing.footer_tagline')}
            </p>
          </div>

          <div>
            <h3 className="font-semibold text-gray-900 mb-4">{t('marketing.footer_col_products')}</h3>
            <ul className="space-y-2 text-sm text-gray-600">
              <li><Link to="/pricing" className="hover:text-gray-900 transition-colors">{t('marketing.footer_ai_analysis')}</Link></li>
              <li><Link to="/pricing" className="hover:text-gray-900 transition-colors">{t('marketing.footer_virtual_try_on')}</Link></li>
              <li><Link to="/pricing" className="hover:text-gray-900 transition-colors">{t('marketing.footer_salon_platform')}</Link></li>
              <li><Link to="/pricing" className="hover:text-gray-900 transition-colors">{t('marketing.footer_style_library')}</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="font-semibold text-gray-900 mb-4">{t('marketing.footer_col_solutions')}</h3>
            <ul className="space-y-2 text-sm text-gray-600">
              <li><Link to="/pricing" className="hover:text-gray-900 transition-colors">{t('marketing.footer_salons')}</Link></li>
              <li><Link to="/pricing" className="hover:text-gray-900 transition-colors">{t('marketing.footer_beauty_brands')}</Link></li>
              <li><Link to="/pricing" className="hover:text-gray-900 transition-colors">{t('marketing.footer_freelance_stylists')}</Link></li>
              <li><Link to="/pricing" className="hover:text-gray-900 transition-colors">{t('marketing.footer_beauty_schools')}</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="font-semibold text-gray-900 mb-4">{t('marketing.footer_col_support')}</h3>
            <ul className="space-y-2 text-sm text-gray-600">
              <li><Link to="/pricing" className="hover:text-gray-900 transition-colors">{t('marketing.footer_documentation')}</Link></li>
              <li><Link to="/pricing" className="hover:text-gray-900 transition-colors">{t('marketing.footer_api_reference')}</Link></li>
              <li><Link to="/pricing" className="hover:text-gray-900 transition-colors">{t('marketing.footer_help_center')}</Link></li>
              <li><Link to="/pricing" className="hover:text-gray-900 transition-colors">{t('marketing.footer_contact_sales')}</Link></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-200 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-sm text-gray-500">
            © {new Date().getFullYear()} Hairchitech. {t('marketing.footer_rights_reserved')}
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0">
            <Link to="/privacy-policy" className="text-sm text-gray-500 hover:text-gray-900 transition-colors">{t('marketing.footer_privacy_policy')}</Link>
            <Link to="/terms-and-conditions" className="text-sm text-gray-500 hover:text-gray-900 transition-colors">{t('marketing.footer_terms')}</Link>
            <Link to="/cookie-policy" className="text-sm text-gray-500 hover:text-gray-900 transition-colors">{t('marketing.footer_cookie_policy')}</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default PublicFooter;
